import { ENABLE_FINANCIAL_AID_PROGRAM } from "../config/constants";

export const staticContent = {
  introVideoUrl: "https://www.youtube.com/watch?v=_a78SNKU7jU",
  courseCombo: {
    primaryCourseId: "",
    secondaryCourseId: "",
  },
  faqs: [
    {
      question: "Are there any prerequisites to enroll in a course?",
      answer:
        "Most of our courses don’t require any prior experience. If a course has specific requirements, we’ll let you know in the course description.",
    },
    {
      question: "Can I access the courses at my own pace?",
      answer: "Absolutely! All our courses are self-paced, so you can learn whenever it’s convenient for you.",
    },
    {
      question: "What if I have questions while taking a course?",
      answer:
        "You can reach out to the course instructor or use our social groups to get help from peers and teacher. We’re here to support you every step of the way!",
    },
    {
      question: "How much do the courses cost?",
      answer:
        "Each course is priced individually, depending on the content and expertise provided. You can find the exact price on the course details page. We occasionally offer discounts and promotions, so keep an eye out for those!",
    },
    {
      question: "Can I get a refund if I'm not satisfied with a course?",
      answer:
        "Since you gain immediate access to all course materials upon purchase, we do not offer refunds. We encourage you to review the course details carefully before making a decision. If you have any questions, feel free to reach out to us beforehand!",
    },
    ENABLE_FINANCIAL_AID_PROGRAM && {
      question: "I cannot afford the course fee at all. What should I do?",
      answer:
        "No worries. We don’t want money to stop anyone from learning a skill that can change their life. You can apply for full financial aid by contacting us on WhatsApp. We’ll guide you through the simple process and help you get enrolled for free if you’re eligible.",
    },
    ENABLE_FINANCIAL_AID_PROGRAM && {
      question: "Who is eligible for financial aid?",
      answer:
        "Anyone who is genuinely unable to afford the full course fee can apply. Whether you are a student, unemployed, or going through a difficult financial phase — if you’re serious about learning, we’re here to support you.",
    },
    ENABLE_FINANCIAL_AID_PROGRAM && {
      question: "Will I get full access to the course if I receive financial aid?",
      answer:
        "Yes, absolutely. Whether you pay a partial amount or receive full aid, you will get full access to all course videos, materials and updates — just like every other student.",
    },
    // {
    //   question: "Do I get a certificate after completing a course?",
    //   answer:
    //     "Yes! Upon successfully completing a course, you'll receive a certificate to showcase your new skills and knowledge.",
    // },
  ].filter((item): item is { question: string; answer: string } => Boolean(item)),
  features: [
    {
      title: "Join a Thriving Community of E-commerce Store Administrators",
      description:
        "Join our community to expand your knowledge, connect with experts, and get support whenever you need it.",
      icon: "sparkles",
      iconBackgroundColor: "#ecfccb",
      iconForegroundColor: "#65a30d",
    },
    {
      title: "Gain Insights with Helpful Blogs and Resources Tailored for You",
      description: "Stay updated with the latest trends through informative blog posts.",
      icon: "book-open",
      iconBackgroundColor: "#dbeafe",
      iconForegroundColor: "#2563eb",
    },
    {
      title: "Achieve Certification to Validate Your E-commerce Skills and Knowledge",
      description: "Earn a certificate upon course completion to showcase your expertise.",
      icon: "party-popper",
      iconBackgroundColor: "#fce7f3",
      iconForegroundColor: "#db2777",
    },
  ],
  mockReviews: [
    {
      firstName: "Awais",
      lastName: "A",
      username: "",
      userImageUrl: "https://avatar.vercel.sh/alice",
      reviewText:
        "This course worth the price. I have learned many skills related to e-commerce services and freelancing.",
      rating: 5,
      reviewedAt: "2025-02-14",
    },
    {
      firstName: "Mohsin",
      lastName: "S",
      username: "",
      userImageUrl: "https://avatar.vercel.sh/bob",
      reviewText:
        "Bohat acha course hai. har cheez ko detail me explain kiya hai. Mai bht dair se aik authentic or detailed course ki talash me tha or finally muje ye course mil gya",
      rating: 5,
      reviewedAt: "2025-01-30",
    },
    {
      firstName: "Sara",
      lastName: "A",
      username: "",
      userImageUrl: "https://avatar.vercel.sh/charlie",
      reviewText: "Bht kuch seekhnay ko mila. Perfect course hai. Highly recommended!",
      rating: 5,
      reviewedAt: "2025-03-22",
    },
    {
      firstName: "Aima",
      lastName: "M",
      username: "",
      userImageUrl: "https://avatar.vercel.sh/daisy",
      reviewText:
        "Ye pehla course hai jis me har cheez ko achy se samjhaya gya hai. Mai is field me new hun lekin mai ne yahan se bht kuch seekha hai. InshaAllah jald he mai freelancing start kr dun gi. Thank you so much for this course!",
      rating: 5,
      reviewedAt: "2025-04-10",
    },
    {
      firstName: "Kamran",
      lastName: "A",
      username: "",
      userImageUrl: "https://avatar.vercel.sh/eve",
      reviewText: "Finally a course full of knowledge.",
      rating: 5,
      reviewedAt: "2025-02-07",
    },
    {
      firstName: "Umar",
      lastName: "N",
      username: "",
      userImageUrl: "https://avatar.vercel.sh/frank",
      reviewText: "Perfect course. This course has everything you need to learn to start earning online.",
      rating: 5,
      reviewedAt: "2025-01-12",
    },
    {
      firstName: "Shehroz",
      lastName: "A",
      username: "",
      userImageUrl: "https://avatar.vercel.sh/jack",
      reviewText: "Price k lehaz se ye course bht acha hai. Bht ziada chezen sikhai hain is me. Thank you!!!",
      rating: 5,
      reviewedAt: "2025-03-01",
    },
    {
      firstName: "Mehwish",
      lastName: "J",
      username: "",
      userImageUrl: "https://avatar.vercel.sh/jill",
      reviewText: "I am feeling like I am an expert now. Thank you for this amazing course.",
      rating: 5,
      reviewedAt: "2025-04-20",
    },
    {
      firstName: "Afifa",
      lastName: "A",
      username: "",
      userImageUrl: "https://avatar.vercel.sh/john",
      reviewText:
        "Agr ap skills seekhna chahty hain or online earning start krna chahty hain to ye course best hai. Mere pass koi b skills nai thin lekin mai ne yahan se bht kuch seekha and now I am feeling confident!!!",
      rating: 5,
      reviewedAt: "2025-03-15",
    },
  ],
  upworkTestimonials: [
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFC91v6llF3dqMp7taZSgHwDme4XhlnvoY8KUkE",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCR2huIcvB8jfZiHyYd4Tvb0R9WMxN2nqDFSIg",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFC6aG27e19kXcFqAfv4eld23EoOZiVLMmySU7u",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCpQr77f5BvNu3CUxMR2rb8fTFEsGeXPotqZYc",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCrBJ0sBfYQUsA6mkvtGCyxqX38zidPD5VlSjp",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFC4PUP1nmOk1lnBDLjmKs4q0RcvzQe8ISJyNiF",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCQ4vW7hczls7TZp5MRIkN2DH4aXnc6reGbQyY",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCllfBueOj5D468O2xEYkpINwmUZP91GCye30n",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCoYWgko2HIDFOjdaJG6b2nxmh1QeNUug7pZKL",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCXJswOxp1w8HKo2LarR4Q1SzdMUtlG0himCAq",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCfeAiyFNaKY0muIqpOV326nsRvELkUxzZ9gDe",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFC0YuR9O6LZ4RAOepIGN5ouc36Ud7hQCv0ywgj",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCQ1BppMczls7TZp5MRIkN2DH4aXnc6reGbQyY",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCQU8T4xczls7TZp5MRIkN2DH4aXnc6reGbQyY",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCRHoacjvB8jfZiHyYd4Tvb0R9WMxN2nqDFSIg",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCgM4Q6rEr0TFahyZLHYvNwmlQ49iVcopJA1PI",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCKmAcRQhG7z5WxINdUy2QmX3AoSYCePJV8fcn",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCo1MzkB2HIDFOjdaJG6b2nxmh1QeNUug7pZKL",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCC9sYTExDG3AFC8S7wfNVDxZsQmLqabhjEXY5",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFC3ke9IIXPA5jpUtDrEoK0JasnfINOR3WkTl9B",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFC7Y0Ps2ugG3HnTl2AROj6Pyb9iFSDYeJ0LoQh",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCuSeQ5tiDZIG3EpJenfj01o4vTX7CR6rx8OLk",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCsGHxcLoSBIepzTR9diGmVPosL2Hf0t51QqMg",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCHJZmxaWfRcYl3W5wJ9QUDpLjHZ72O4Ex8G0z",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCLp741miU7uLTEXsjS3RoOkwI0BPnlWzbK6dq",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCAeaI3dLNhVZn6i5GwaSbPT2WOxgpfUJedIMR",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCjvSkdKxGZEnSvC0J8tacF21hIdT6MxRkVUfr",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCTC7u9TGtoyPFe9jEAYg8xU50BQH62LSdmXbv",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCD3xrTFMZCa0cRl2i3DYpE7OBUzAhnTKqeoFg",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFC7Vvm18ugG3HnTl2AROj6Pyb9iFSDYeJ0LoQh",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCcveelxCKPFUyV6DHsuIx2Nawg4zm9dRfjGLk",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCMPBb0p9s5NrJXx817jQhGZCVScmKiOlLeHok",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCTjlkozGtoyPFe9jEAYg8xU50BQH62LSdmXbv",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFC91wNuuY3dqMp7taZSgHwDme4XhlnvoY8KUkE",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCLdpZolU7uLTEXsjS3RoOkwI0BPnlWzbK6dqh",
    },
    {
      screenshotImageUrl: "https://w0xvwjwpuz.ufs.sh/f/C9ZnxEDG3AFCvtwfCqTfSKoNbawPBs2XEDy8LJepUg6kHhzm",
    },
  ],
  socialTestimonials: [
    {
      screenshotImageUrl: "",
    },
  ],
  upworkEarningAndStats: [
    {
      screenshotImageUrl: "",
    },
  ],
  courseBenefits: [
    "Proven System to Start Earning $1000+/Month",
    "Step-by-Step Training with No Experience Needed",
    "Work from Home & Achieve Financial Freedom",
    "Learn at Your Own Pace – No Deadlines",
    "Real Client Scenarios & Practical Case Studies",
    "Free Updates as the Course Evolves",
    "Lifetime Access to All Course Materials",
    "Access to Private Q&A Community for Support",
    "Bonus Guides & Surprise Perks Inside Community",
    "Certificate of Completion to Boost Your Resume",
  ],
  landingPage: {
    heroSection: {
      title: "Learn skills and make money online",
      subtitle:
        "Master e-commerce admin skills and become an in-demand expert.  You'll never struggle with work again!",
      announcementBadgeTitle: "E-commerce Store Administration Course is out now! 🎉",
    },
    primaryCourseSection: {
      label: "Featured",
      title: "Go from Beginner to an E-commerce Pro",
      subtitle: "Learn everything about e-commerce store administration and freelancing. All in one place!",
    },
    coursesSection: {
      label: "Courses",
      title: "Jam Packed Courses To Help You Succeed",
      subtitle: "Explore our top courses loved by students just like you!",
    },
    featuresSection: {
      label: "Features",
      title: "Get exclusive benefits with our courses",
      subtitle: "Learn the Essentials and Beyond with Our Feature-Rich Courses!",
    },
    reviewsSection: {
      label: "Wall of Love",
      title: "Reviews from our amazing students",
      subtitle: "Hear how our course have made a difference in their e-commerce journeys!",
    },
    upworkTestimonialsSection: {
      label: "Upwork Testimonials",
      title: "What clients say about working with me",
      subtitle: "Real feedback from satisfied clients who trusted me with their projects.",
    },
    aboutTheAuthorSection: {
      label: "Meet the teacher",
      title: "Hi! I'm Asad 👋",
      subtitle: "E-commerce Specialist",
      bio: "<p>I'm a Top Rated freelancer and a passionate E-commerce Specialist. With years of experience managing online stores, I specialize in product listing, inventory management, store management, customer service and more. I’ve worked extensively with platforms like Shopify, WooCommerce, and Magento, helping businesses streamline operations and boost sales.</p><p>I have earned <strong>$80K+ on Upwork</strong> alone and have worked with some amazing high-value clients, handling projects worth <strong>$32,000, $12,000, and $5,000</strong>. Through these experiences, I’ve gained deep insights into e-commerce. Now, I want to teach these skills to the youth of my country in just 14 days, empowering them to earn, become financially independent, and improve their lifestyle.</p><p>I acquired this knowledge over a long period, but I want to give it to others in the shortest time possible. If I can do this, you can also do this!</p><p>Enroll now and start your journey today!</p>",
    },
    blogsSection: {
      label: "Blogs",
      title: "Tips, insights, and advice to keep you ahead",
      subtitle: "Short blog posts to keep your learning journey thriving!",
    },
    newsletterSection: {
      title: "Get the latest news and updates delivered to your inbox",
      description:
        "Sign up with your email address to receive the FREE guide: 10 Simple Steps to Start Your Freelancing Career with E-commerce Admin Skills.",
    },
    faqsSection: {
      title: "Frequently asked questions",
    },
  },
  courses: [
    {
      slug:
        process.env.NODE_ENV === "development"
          ? "e-commerce-master-class"
          : "mastering-e-commerce-store-administration-and-freelancing",
      variants: [
        {
          id: "simple",
          label: "Course Only",
          additionalPrice: 0,
          details: {
            intro: "Perfect for self-learners who want maximum value at minimum cost.",
            bullets: [
              "Full lifetime access to all course videos",
              "Step-by-step guidance to help you learn at your own pace",
              "Support for any technical issues (account, website, playback etc.)",
            ],
            outro:
              "Even without mentorship, this course is designed to be fully self-sufficient — learn the skills, apply them, and start your journey confidently.",
          },
        },
        {
          id: "with-mentorship",
          label: "Course + Mentorship",
          additionalPrice: 4990,
          details: {
            intro: "Everything in the Course Only plan, plus personal mentorship from me.",
            bullets: [
              "Direct support via call or message whenever you need advice or guidance",
              "Priority help with your problems or questions",
              "The opportunity to meet me in person for one-on-one mentorship & guidance",
            ],
            outro: "This is the fast track to mastering your skills with full support at every step.",
          },
        },
      ],
    },
  ],
};

export const primaryCourseContent = staticContent.courses?.[0];
